"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AllDocuments;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const native_1 = require("@react-navigation/native");
const useDevice_1 = require("../../../hooks/useDevice");
const useRequest_1 = __importDefault(require("../../../hooks/useRequest"));
const AppLoader_1 = __importDefault(require("../../../component/AppLoader"));
const DocumentCard_1 = __importStar(require("../../../component/documents/DocumentCard"));
const GenerateSummaryButton_1 = __importDefault(require("../../../component/documents/GenerateSummaryButton"));
const document_1 = require("../../../services/document");
const spacing_1 = require("../../../common/spacing");
const DOCUMENTS_CARD_VERTICAL_GAP = 24;
const DOCUMENTS_CARD_VERTICAL_GAP_MOBILE = 14;
const MAX_CARD_NUMBER = 4;
function AllDocuments() {
    const { navigate } = (0, native_1.useNavigation)();
    const { isMobileScreen, mainWidth } = (0, useDevice_1.useDevice)();
    const { request } = (0, useRequest_1.default)();
    const [documents, setDocuments] = (0, react_1.useState)();
    const usableWidth = (0, react_1.useMemo)(() => (isMobileScreen
        ? mainWidth - styles.contentMobile.paddingHorizontal * 2
        : mainWidth <= styles.container.maxWidth
            ? mainWidth - styles.contentShrinked.paddingHorizontal * 2
            : mainWidth), [isMobileScreen, mainWidth]);
    const cardWidth = (0, react_1.useMemo)(() => (isMobileScreen ? DocumentCard_1.DOCUMENT_CARD_BASE_WIDTH_MOBILE : DocumentCard_1.DOCUMENT_CARD_BASE_WIDTH), [isMobileScreen]);
    const cardHorizontalGap = (0, react_1.useMemo)(() => (isMobileScreen ? DOCUMENTS_CARD_VERTICAL_GAP_MOBILE : DOCUMENTS_CARD_VERTICAL_GAP), [isMobileScreen]);
    const numberOfColumns = (0, react_1.useMemo)(() => (Math.floor(Math.max(Math.min((usableWidth + cardHorizontalGap) / (cardWidth + cardHorizontalGap), MAX_CARD_NUMBER), 1))), [usableWidth, cardWidth, cardHorizontalGap]);
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        const fetchDocuments = async () => {
            const fetchedDocuments = await request(document_1.getAllDocuments);
            if (isMounted && fetchedDocuments) {
                setDocuments(fetchedDocuments);
            }
            ;
        };
        fetchDocuments();
        return () => { isMounted = false; };
    }, [request]);
    (0, react_1.useEffect)(() => {
        const contentDocuments = documents?.filter((document) => document);
        if (documents && contentDocuments) {
            if (documents.length % numberOfColumns !== 0) {
                const columnsToAdd = numberOfColumns - contentDocuments.length % numberOfColumns;
                setDocuments([...contentDocuments, ...Array.from(Array(columnsToAdd), () => null)]);
            }
            else if (documents.length - contentDocuments.length >= numberOfColumns) {
                setDocuments(contentDocuments);
            }
        }
    }, [documents, numberOfColumns]);
    const renderItem = (0, react_1.useCallback)(({ item }) => (item ? ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => navigate('Summary', { shareId: item.shareId }), style: styles.cardContainer, children: (0, jsx_runtime_1.jsx)(DocumentCard_1.default, { sharedDocument: item }) })) : ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.invisibleCard }))), [isMobileScreen, numberOfColumns]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.container, isMobileScreen && styles.containerMobile], children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [
                        styles.content,
                        mainWidth <= styles.container.maxWidth
                            ? styles.contentShrinked
                            : isMobileScreen && styles.contentMobile,
                    ], children: !documents ? ((0, jsx_runtime_1.jsx)(AppLoader_1.default, { isLoading: true, showLoader: true, darkBg: true })) : ((0, jsx_runtime_1.jsx)(react_native_1.FlatList, { data: documents, renderItem: renderItem, numColumns: numberOfColumns, showsVerticalScrollIndicator: false, style: [styles.listContainer, isMobileScreen && styles.listContainerMobile], contentContainerStyle: styles.listRowWrapper, columnWrapperStyle: numberOfColumns > 1
                            ? [styles.listColumnWrapper, {
                                    columnGap: isMobileScreen
                                        ? DOCUMENTS_CARD_VERTICAL_GAP_MOBILE
                                        : DOCUMENTS_CARD_VERTICAL_GAP,
                                }]
                            : undefined }, `all-documents-${numberOfColumns}`)) }) }), (0, jsx_runtime_1.jsx)(GenerateSummaryButton_1.default, {})] }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        width: '100%',
        maxWidth: 872,
        alignSelf: 'center',
        flex: 1,
    },
    containerMobile: {
        paddingBottom: 80,
    },
    content: {
        flex: 1,
    },
    contentShrinked: {
        paddingHorizontal: 20,
    },
    contentMobile: {
        paddingHorizontal: 17,
    },
    listContainer: {
        paddingBottom: 12,
        paddingTop: 12,
    },
    listContainerMobile: {
        paddingBottom: 12,
    },
    listRowWrapper: {
        rowGap: spacing_1.Spacing.SPACING_3XL,
    },
    listColumnWrapper: {
        justifyContent: 'center',
    },
    cardContainer: {
        flex: 1,
    },
    invisibleCard: {
        opacity: 0,
        flex: 1,
    },
});
